import React from "react";

const TermsAndConditions = () => {
  document.title = `Terms & Conditions | Bigmall`;
  return (
    <div className="container-lg my-5">
      <h3 className="mb-5">Terms and Conditions</h3>

      {/* ACCEPTANCE OF TERMS OF USE */}
      <section className="mb-5">
        <h6 className="fw-bold mb-3">ACCEPTANCE OF TERMS OF USE</h6>
        <p>
          Accessing or employing the Bigmall website or the services offered by the same is deemed acceptance to be bound by the subsequent terms and conditions upon the Site. In case you do not agree with some of these terms, please be discontinued.
        </p>
      </section>

      {/* DETAILS WE COLLECT */}
      <section className="mb-5">
        <h6 className="fw-bold mb-3">DETAILS WE COLLECT</h6>
        <p>
          When a user registers an account on Bigmall, we collect the necessary personal data i.e., name, email address, phone number, or delivery address to support account management, order processing, and other.
        </p>
        <p>
          Bigmall is dedicated to maintaining customer’s privacy. It also ensures secrecy concerning personal information of individuals. It is worth noting that we do not process clients’ personal information (including names, e-mails, phone numbers, and so on) for promoting, advertising purposes, and any other unauthorized needs without prior consent.
        </p>
        <p>
          Do not worry, whatever customer’s information used is exclusively meant for orders processing, services provisioning and smooth shopping. Our topmost consideration is safety, as we comply with Sri Lankan data protection Act. Big Mall ensures that it maintains confidentiality of user’s information by not sending their details or selling them to other parties.
        </p>
      </section>

      {/* ORDER ELIGIBILITY */}
      <section className="mb-5">
        <h6 className="fw-bold mb-3">ORDER ELIGIBILITY</h6>
        <p>
          Users must fulfil the following eligibility conditions to make orders on Bigmall's website: in Sri Lanka, persons should be legal aged or have parents/guardians consent (if under the legal age). Additionally, users should also provide the purchase processing and shipping information as well as an accepted valid payment method approved by Bigmall. By placing an order, users confirm that they are eligible and meet these conditions.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
